import axiosCli from "../vue/axios/axios";

async function getPendingEvents(params, headers) {
  return await axiosCli.get('/company_monitorings/get_location_pending_events_facial', {
    params,
    headers,
  });
}

async function proccessEvent(body) {
  return await axiosCli.post('/company_monitorings/update_reviewed_event', body);
}

async function sendToValidate(body, headers) {
  return await axiosCli.post('/company_monitorings/get_pair_event_to_validate', body, {headers});
}

async function getPendingValidations(params) {
  return await axiosCli.get('/company_monitorings/pending_validation_pairs', {params});
}

export default {
  getPendingEvents,
  proccessEvent,
  sendToValidate,
  getPendingValidations
}